import { render } from "./ClinicConnectorsTab.vue?vue&type=template&id=64a18b88&scoped=true"
import script from "./ClinicConnectorsTab.js?vue&type=script&lang=js&external"
export * from "./ClinicConnectorsTab.js?vue&type=script&lang=js&external"

import "./ClinicConnectorsTab.vue?vue&type=style&index=0&id=64a18b88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a18b88"]])

export default __exports__